import React from 'react';
import { motion } from 'framer-motion';
import { CountUpNumber } from '../visualizations/CountUpNumber';
export function Slide03MarketTruth() {
  const stats = [{
    value: 52,
    suffix: '%',
    label: 'ads disrupt experience',
    color: '#ef4444'
  }, {
    value: 49,
    suffix: '%',
    label: 'too much advertising',
    color: '#f97316'
  }, {
    value: 6,
    prefix: '2-',
    suffix: '%',
    label: 'trust digital advertising',
    color: '#ffd700'
  }, {
    value: 0,
    customDisplay: 'ROI↓',
    label: 'CPM increasing while returns drop',
    color: '#4fd1c5'
  }];
  return <div className="flex flex-col h-full justify-center max-w-6xl mx-auto w-full" data-id="element-52">
      <motion.h2 className="text-5xl font-bold text-white mb-20 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-53">
        Market Truth:{' '}
        <span className="text-[#ffd700]" data-id="element-54">Consumers Ignore Ads</span>
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-55">
        {stats.map((stat, i) => <motion.div key={i} initial={{
        y: 50,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: i * 0.1,
        type: 'spring',
        stiffness: 100
      }} className="flex flex-col items-center text-center p-8 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors" data-id="element-56">
            <div className="text-6xl font-bold mb-4" style={{
          color: stat.color
        }} data-id="element-57">
              {stat.customDisplay ? stat.customDisplay : <CountUpNumber value={stat.value} suffix={stat.suffix} prefix={stat.prefix} delay={0.5 + i * 0.1} data-id="element-58" />}
            </div>
            <p className="text-xl text-white/80 font-medium leading-tight" data-id="element-59">
              {stat.label}
            </p>
          </motion.div>)}
      </div>
    </div>;
}